import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = [ "bunny-player" ];

  connect() {
  }

  disconnect() {
  }

  play() {
    if (!this.hasBunnyPlayerOutlet) return;

    this.bunnyPlayerOutlet.play();
  }

  pause() {
    if (!this.hasBunnyPlayerOutlet) return;

    this.bunnyPlayerOutlet.pause();
  }

  replay() {
    if (!this.hasBunnyPlayerOutlet) return;

    this.bunnyPlayerOutlet.replay();
  }

  toggleMute() {
    if (!this.hasBunnyPlayerOutlet) return;

    this.bunnyPlayerOutlet.toggleMute();
  }

  mute() {
    if (!this.hasBunnyPlayerOutlet) return;

    this.bunnyPlayerOutlet.mute();
  }
}
